/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-12 21:44:03
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare ఓపెన్ చేయండి",
    name2: "రిజర్వేషన్ చేయండి",
    name3: "Carlcareతో, మీరు ఏ సమయంలోనైనా మీ ఆర్డర్‌ని చెక్ చేయవచ్చు.",
    name4: "",
    name5: "కుడివైపుకు స్లైడ్ చేయండి",
    name6: "ధృవీకరణ పూర్తయింది",
  },
  order: {
    name1: "పరికరం మోడల్ ఎంచుకోండి",
    name2: "లోపం వివరణ:",
    name3: "సర్వీస్ స్టోర్‌ని ఎంచుకోవడానికి తట్టండి",
    name4: "సర్వీస్ స్టోరు:",
    name5: "రిజర్వేషన్ టైమ్:",
    name6: "దయచేసి మీ పరికరం‌ సమస్యను సవిస్తరంగా వివరించండి!",
    name7: "రాక సమయాన్ని ఎంచుకోవడానికి తట్టండి",
    name8: "దయచేసి మీ సరైన కాంటాక్ట్ వివరాలను నమోదు చేయండి తద్వారా మేం మిమ్మల్ని సంప్రదిస్తాం",
    name9: "లభ్యమవుతున్న రిజర్వేషన్ సమయం దిగువ పేర్కొన్నవిధంగా ఉంటుంది",
    name10: "దయచేసిమీఫోన్ నంబర్ నమోదు",
    name11: "ధర",
    name12: "వ్యక్తిగత సమాచారం:",
    name13: "దయచేసి మీ పేరును నమోదు చేయండి",
    name14: "సమర్పించు",
    name15: "రద్దు చేయి",
    name16: "ఒకే",
  },
  shops: {
    name1: "మీరు ఎంచుకున్న బ్రాండ్ ఆధారంగా, దిగువ స్టోర్‌లు మీకు సేవనందిస్తాయి!",
    name2: "త్వరలో మరిన్ని రిటైల్ స్టోర్లకు రాబోతోంది! వేచి ఉండండి!",
  },
  price: {
    name1: "బ్రాండ్",
    name2: "మోడల్",
    name3: "ఐటమ్",
    name4: "ధర",
    name5: "స్నేహపూర్వకంగా గుర్తు చేయడం:",
    name6: "ఈ పీస్‌లు కేవలం రిఫరెన్స్ కొరకు మాత్రమే, మరియు వాస్తవ ధర మీ పరికరం పరిస్థితికి లోబడి ఉంటుంది.",
    name7: "ఒకవేళ ఎలాంటి ప్రత్యేక గుర్తు లేనట్లయితే, ధర యూనిట్ స్థానిక కరెన్సీ యూనిట్.",
    name8: "క్షమించండి! ప్రస్తుత ప్రాంతంలో ధర సమాచారం లభ్యం కావడం లేదు.",
    name11:"లేబర్ ఖర్చు",
    name12:"మొత్తం ధర",
    name13: "5. లేబర్ ఖర్చు \"/\" అయితే, లేబర్ ఖర్చు గురించి స్టోరును సంప్రదించాలని అర్థం.",
    item_main_board: "మెయిన్‌బోర్డు",
    item_screen_frame: "స్క్రీన్ (ఫ్రేమ్)",
    item_screen_screen_frame: "సెకండరీ స్క్రీన్ (ఫ్రేమ్)",
    item_touch_screen: "టచ్ స్క్రీన్",
    item_camera: "కెమెరా",
    item_fixed_focus_camera: "ఫిక్సిడ్ ఫోకస్ కెమెరా",
    item_auto_focus_camera: "ఆటో ఫోకస్ కెమెరా",
    item_screen: "స్క్రీన్",
    item_secondary_screen: "సెకండరీ స్క్రీన్",
    item_fingerprint_module: "వేలిముద్ర మాడ్యూల్",
    item_speaker: "స్పీకర్",
    item_receiver: "స్వీకరించండి",
    item_small_board: "చిన్న బోర్డు",
    item_battery_cover: "బ్యాటరీ కవర్",
    item_battery: "బ్యాటరీ",
    item_charger: "ఛార్జర్",
    item_usb_cable: "USB కేబుల్",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "ఏ డేటా",
    name2: "సర్వీస్ ప్రొవైడర్:",
    name3: "సర్వీస్ బ్రాండ్:",
    name4: "టెలిఫోన్:",
    name5: "ఆర్డర్ పరిమాణం:",
    name6: "సర్వీస్ రేటింగ్",
    name7: "సర్వీస్ వాతావరణం:",
    name8: "సర్వీస్ దృక్పథం:",
    name9: "సర్వీస్ సామర్థ్యం:",
    name10: "సర్వీస్ నాణ్యత:",
    name11: "కస్టమర్ మదింపు",
    name12:"కు",
    name13:"మూయబడింది",
  },
  reserSuccess: {
    // name1:
    //   "Carlcare ఓపెన్ చేయండి",
    name1: "దయచేసి రిజర్వేషన్ సమాచారాన్ని స్క్రీన్‌షాట్ చేయండి మరియు ప్రయారిటీ సర్వీస్‌ని యాక్సెస్ చేసుకోవడానికి రసీదు వలే దానిని సేవ్ చేయండి.",
    name2: "విజయవంతంగా సబ్మిట్ చేయబడింది",
    name3: "1. డేటాను క్లిక్ చేయండి",
    name4: "దయచేసి ముందస్తుగా మీ ఫోన్‌లోని ముఖ్యమైన ప్రైవేట్ డేటాను బ్యాకప్ చేయండి",
    name5: "2. పవర్ ఆన్ పాస్‌వర్డ్‌ని నిలిపివేయండి",
    name6: "సర్వీస్ స్టోరుకు వెళ్లడానికి ముందు, దయచేసి:",
    name7: "సర్వీస్ స్టోరు:",
    name8: "రిజర్వేషన్ టైమ్:",
    name9: "లోపం వివరణ:",
    name10: "పరికరం మోడల్:",
    name11: "ఆర్డర్ నెంబరు:",
    name12: "ఆర్డర్సమాచారం",
  },
  title: {
    
    name1: "దిగువ దేశాలకు మద్దతు ఇస్తుంది:",
    name2: "మోడల్ ఎంచుకోండి",
    name3: "రిజర్వేషన్",
    name4: "సర్వీస్ స్టోరు వివరాలు",
    name5: "సర్వీస్ స్టోర్ ఎంచుకోండి",
  },
  error: {
    
    name1: "డేటా లేదు. దయచేసి మీ రిపేర్ సమాచారాన్ని చెక్ చేయండి",
    name2: "మరింత సాయం కావాలా? దయచేసి మమ్మల్ని సంప్రదించండి.",
    name3: "క్షమించండి, ప్రస్తుత ప్రాంతంలో Carlcare సెంటర్ లేదు.",
    name4: "దయచేసి ముందుగా ఒక సర్వీస్ సెంటర్ ఎంచుకోండి!",
    name5: "విఫలమైంది",
    name6: "దయచేసి ముందుగా పరికరం మోడల్ ఎంచుకోండి!",
    name7: "వివరాలు",
    name8: "దయచేసి మీ అవసరాలను సవిస్తరంగా వివరించండి",
    name9: "",
  },
  add1:{
    "name0": "te-rIN",
    "name1": "మీ ఆర్డర్ ధృవీకరించబడింది. మీ రాక కొరకు మేం ఎదురుచూస్తున్నాం.",
    "name2": "నగరాన్ని ఎంచుకోండి",
    "name3": "దయచేసి %1$s అంకెల ఫోన్ నెంబర్\u200cని ఇన్\u200cపుట్ చేయండి.",
    "name4": "వారం గంటలు",
    "name5": "\"సోమవారం\"",
    "name6": "మంగళవారం",
    "name7": "బుధవారం",
    "name8": "గురువారం",
    "name9": "శుక్రవారం",
    "name10": "\"శనివారం\"",
    "name11": "\"ఆదివారం\"",
    "name12": "దేశం నమోదు చేయండి మరియు వెతకండి"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "ఇతరులు",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"రీడైరెక్ట్‌ను ట్యాప్ చేయి",
    name3:"ఆర్డర్‌ను రేట్ చేయడానికి Carlcare యాప్‌ను తెరవండి",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"సర్వీస్ ఎంచుకోండి",
    name7:"ఉచితంగా క్లీన్ చేయడం",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "తప్పు సమాచారం",
    "cancelReason1": "సకాలంలో రాలేదు",
    "cancelReason2": "డూప్లికేట్ ఆర్డర్/నా ఆర్డర్ కాదు",
    "cancelReason3": "వైఫల్యం పునరావృతం కాదు",
    "cancelReason4": "కేవలం టెస్ట్/ఎంక్వైరీ/ఈవెంట్ కొరకు/…",
    "cancelReason5": "అధిక ధర",
    "cancelReason6": "మెటీరియల్ కొరత",
    "cancelReason7": "విభిన్న సర్వీస్‌లు లేవు",
    "cancelReason8": "స్టోరు చాలా దూరంగా ఉంది",
    "cancelReason9": "స్టోరు మూసివేయబడింది",
    "cancelReason10": "చెడ్డ సర్వీస్ దృక్పథం",
    "cancelReason11": "ఇతర బ్రాండ్‌ల కొరకు రీప్లేస్ మెంట్/రిపేర్",
    "cancelReason12": "స్టోరును కనుగొనలేకపోయింది",
    "cancelReason13": "ఇతర",
    "cancelOrder": "ఆర్డర్ క్యాన్సిల్ చేయండి",
    "reason_dialog_title": "దయచేసి రద్దు చేయడానికి కారణాన్ని మాకు తెలియజేయండి",
    "Cancel": "రద్దు చేయండి",
    "OK": "సరే",
    "name1": "ధృవీకరణ కోడ్ నమోదు చేయి",
    "name2": "చెల్లుబాటు కాని ధృవీకరణ కోడ్",
    "repair_reservation_detail_canceled": "ఈ ఆర్డర్ క్యాన్సిల్ చేయబడింది!",
    "purchase_cancel_dialog_content": "ఆర్డర్ రద్దు చేయడాన్ని మీరు నిర్ధారిస్తారా?",
    "yes": "అవును",
    "no": "ఏ"
}
};
